var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightInterview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54995 5.7C8.54995 7.27401 7.27396 8.55 5.69995 8.55C4.12594 8.55 2.84995 7.27401 2.84995 5.7C2.84995 4.12599 4.12594 2.85 5.69995 2.85C7.27396 2.85 8.54995 4.12599 8.54995 5.7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 5.7C16.15 7.27401 14.874 8.55 13.3 8.55C11.7259 8.55 10.45 7.27401 10.45 5.7C10.45 4.12599 11.7259 2.85 13.3 2.85C14.874 2.85 16.15 4.12599 16.15 5.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2826 16.15C12.327 15.8397 12.35 15.5225 12.35 15.2C12.35 13.6466 11.8173 12.2176 10.9247 11.0856C11.6234 10.6814 12.4347 10.45 13.3 10.45C15.9233 10.45 18.05 12.5766 18.05 15.2V16.15H12.2826Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69995 10.45C8.3233 10.45 10.45 12.5766 10.45 15.2V16.15H0.949951V15.2C0.949951 12.5766 3.0766 10.45 5.69995 10.45Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightInterview);
export default __webpack_public_path__ + "static/media/light-interview.28a432397e17df29b830df00cde864bc.svg";
export { ForwardRef as ReactComponent };